<template>
  <div class="text-box" :style="{ '--color': backgroundColor }">
    <p class="aisea-text-14-600-pure-white">{{ text }}</p>
  </div>
</template>

<script>
/**
 * テキストボックスを表示するコンポーネント
 * @parent M.EquipmentVesselCard
 * @props backgroundColor: String テキストボックスの色
 * @props text: String テキストボックスの文字
 */

export default {
  name: "A.TextBox",
  props: {
    backgroundColor: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";
.text-box {
  line-height: 14px;
  border-radius: 4px;
  background: var(--color);
  padding: 4px 10px;
}
</style>
